<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">
  <p-toolbar>
    <ng-template #start>
      <div class="toolbar-menu">
        <p-selectButton [options]="resultsDisplay" [(ngModel)]="selectedResultDisplay"
          (onChange)="onSelectedResultDisplayUpdated($event)" [allowEmpty]="false"></p-selectButton>

        <span>
          <i pTooltip="To determine allowable wear for both burst and collapse, a wall thickness is calculated that results in the load Safety Factor (SF) equal to the respective Design Factor (DF). The resultant wall thickness is then divided by the nominal wall thickness to get allowable wear as a percentage (%). Note that the resultant curve is a composite analysis that accounts for all load cases specified, selecting the worst case at each resultant nodal depth for both burst and collapse individual as well as an overall lower bound inclusive of both." class="pi pi-info-circle pl-4 cursor-help relative z-[2]"></i>
        </span>
      </div>
    </ng-template>
  </p-toolbar>

  @if (selectedResultDisplay === 'plot') {
  <app-single-load-plot 
    [yAxisTitle]="yAxisTitle" [xAxisTitle]="xAxisTitle" [columnDefs]="columnDefs" [data]="results"
    [selectedDepthView]="selectedDepthView" [depthUnit]="longLengthUnit"
    [plotName]="plotName" [plotTitle]="'Max Allowed Wear'" [componentHeight]="componentHeight"
    [singleLoadPlotStore]="casingWearResultsStore">
  </app-single-load-plot>
  }

  <app-single-load-grid 
    [hidden]="selectedResultDisplay !== 'grid'" [rowData]="results"
    [columnDefinitions]="columnDefinitions" 
    tableName="Max Allowed Wear"
    gridName="Max Allowed Wear"
  ></app-single-load-grid>

  <p-dialog [draggable]="false" [visible]="errorMsg != null" [closable]="false" appendTo="self">
    <i class="pi pi-exclamation-circle pr-1"></i>
    <label>{{ errorMsg }}</label>
    <br />
    <br />
  </p-dialog>

  @if (casingWearResults != null) {
    <app-perivis-validation [errors]="casingWearResults?.errors || null" />
  }

</app-tool-loader>
